import moment from 'moment';

const ISO_DATE_MASK = "YYYY-MM-DD";

/**
 * Get the current date in a long string format
 * Eg: 1 March 2024
 * @returns String
 */
export const getLongDateStr = () => {
  return new Intl.DateTimeFormat('en-GB', {
    dateStyle: 'long',
  }).format(new Date());
};

/**
 * Get todays date in ISO foramt YYYY-MM-DD
 */
export const getTodayAsISODate = () => {
  return moment().format(ISO_DATE_MASK);
}

/**
 * Gets the date x months in the future from today
 * 
 * @param {*} months 
 * @returns 
 */
export const getISODateMonthsFromToday = (months) => {
  return moment().add(months, "M").format(ISO_DATE_MASK);
}